import React, { useRef, useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Badge from "@mui/material/Badge";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const drawerWidth = 300;
const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
    position: "fixed",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  appBarBottom: {
    top: "auto",
    bottom: 0,
    [theme.breakpoints.up("sm")]: {},
  },
  grow: {
    flexGrow: 1,
  },
  productListPaper: {
    marginBottom: 50,
  },
}));

const materialTheme = createTheme({
  // set default for now
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function InputSalesInvoiceProductReview(props) {
  const classes = useStyles();
  const [products, setProducts] = useState([]);
  const [totalInvoicedAmount, setTotalInvoicedAmount] = useState(0);
  const [invoicedItemCount, setInvoicedItemCount] = useState(0);
  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [messageDialogMessage, setMessageDialogMessage] = useState("");
  const [openLotNumberAndExpirationDialogInput, setOpenLotNumberAndExpirationDialogInput] =
    useState(false);
  const [selectedProductForLotNumberInput, setSelectedProductForLotNumberInput] = useState(null);

  function orderValue(unit) {
    return unit.order_quantity <= 0 ? "" : unit.order_quantity;
  }

  // function orderInput(product,unit){
  //     return(
  //       <Box display="flex" justifyContent="flex-end" >
  //         <Box p={1} display="flex" justifyContent="center"  flexDirection="column">
  //           <Typography variant="h6" component="span" style={{ fontWeight:600,fontSize:"16px" }}>{unit.price_with_tax} / <small>{unit.uom}</small></Typography>
  //         </Box>
  //         <Box p={1} style={{maxWidth:"100px"}}>
  //         <TextField
  //           id="outlined-size-small"
  //           variant="outlined"
  //           size="small"
  //           type="number"
  //           value = {orderValue(unit)}
  //         />
  //         </Box>

  //       </Box>
  //     )
  //   }
  const onOrderOrPriceInputOnChange = (product, unit) => (event) => {
    const productsCopy = [...products];

    if (event.target.name === "quantity") {
      const orderQuantity = event.target.value;
      unit.order_quantity =
        orderQuantity.length <= 0 || isNaN(orderQuantity) ? 0 : parseFloat(orderQuantity).toFixed();
    } else if (event.target.name === "price") {
      const newPriceWithTax = event.target.value;
      unit.new_price_with_tax =
        newPriceWithTax.length <= 0 || isNaN(newPriceWithTax)
          ? 0
          : parseFloat(newPriceWithTax).toFixed(2);
    }
    saveOrDeleteLocalStorageTempOrder(product);

    setTotalInvoicedAmount(computeOverallTotalInvoiceAmount());
    setInvoicedItemCount(totalInvoicedCount());
    product.total_invoiced_amount = computeTotalInvoiceAmountPerProduct(product);

    setProducts(productsCopy);
  };

  const priceInputOnBlur = (product, unit) => (event) => {
    const currentPrice = unit.current_price_with_tax;
    const newPrice = unit.new_price_with_tax == null ? 0 : unit.new_price_with_tax;

    if (newPrice != null && newPrice.length > 0 && newPrice > 0) {
      return;
    }
    if (currentPrice == null) {
      return;
    }

    const productsCopy = [...products];
    unit.new_price_with_tax = currentPrice;

    saveOrDeleteLocalStorageTempOrder(product);

    setTotalInvoicedAmount(computeOverallTotalInvoiceAmount());
    setInvoicedItemCount(totalInvoicedCount());
    product.total_invoiced_amount = computeTotalInvoiceAmountPerProduct(product);

    setProducts(productsCopy);
  };
  function saveOrDeleteLocalStorageTempOrder(product) {
    const temporarySalesInvoiceString = localStorage.getItem(
      props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
    );
    if (temporarySalesInvoiceString == null) {
      localStorage.setItem(
        props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice",
        JSON.stringify([product])
      );
      return;
    }
    const temporarySalesInvoiceJSON = JSON.parse(temporarySalesInvoiceString);
    const index = temporarySalesInvoiceJSON.findIndex(
      (salesInvoiceProduct) =>
        salesInvoiceProduct.code == product.code &&
        salesInvoiceProduct.company_id == product.company_id
    );

    const hasQuantityOrPriceInput = doProductHasQuantityOrPriceInput(product);

    if (index >= 0) {
      //replace or remove
      if (hasQuantityOrPriceInput == true) {
        temporarySalesInvoiceJSON.splice(index, 1, product); //replace object
      } else if (hasQuantityOrPriceInput == false) {
        temporarySalesInvoiceJSON.splice(index, 1); //remove object
      }
    } else {
      //add
      if (hasQuantityOrPriceInput == true) {
        temporarySalesInvoiceJSON.push(product);
      }
    }

    if (temporarySalesInvoiceJSON.length <= 0) {
      localStorage.removeItem(
        props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
      );
    } else {
      localStorage.setItem(
        props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice",
        JSON.stringify(temporarySalesInvoiceJSON)
      );
    }
  }
  function doUnitHasQuantityOrPrice(unit) {
    if (unit.order_quantity > 0 || unit.new_price_with_tax > 0) {
      return true;
    }
    return false;
  }
  function doProductHasQuantityOrPriceInput(product) {
    for (let x = 0; x < product.Units.length; x++) {
      const unit = product.Units[x];
      const orderQuantity = unit.order_quantity.length > 0 ? Number(unit.order_quantity) : 0;
      const priceWithTax = unit.new_price_with_tax.length > 0 ? Number(unit.new_price_with_tax) : 0;

      if (orderQuantity > 0 || priceWithTax > 0) {
        return true;
      }
    }

    return false;
  }
  function computeTotalInvoiceAmountPerProduct(product) {
    const totalInvoiceValue = Number(
      product.Units.reduce((partialSum, unit) => {
        const priceWithTax =
          unit.new_price_with_tax && unit.new_price_with_tax !== 0
            ? unit.new_price_with_tax
            : unit.current_price_with_tax;
        const amount = parseFloat(unit.order_quantity) * priceWithTax;
        return partialSum + (isNaN(amount) ? 0 : amount);
      }, 0.0)
    );
    return isNaN(totalInvoiceValue) ? 0 : totalInvoiceValue;
  }

  function computeOverallTotalInvoiceAmount() {
    const temporarySalesInvoiceString = localStorage.getItem(
      props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
    );
    if (temporarySalesInvoiceString == null) {
      return 0;
    }
    const temporarySaleInvoiced = JSON.parse(temporarySalesInvoiceString);
    const overallTotalAmount = temporarySaleInvoiced
      .reduce(
        (partialSum, product) => partialSum + computeTotalInvoiceAmountPerProduct(product),
        0.0
      )
      .toFixed(2);

    return overallTotalAmount;
  }
  function totalInvoicedCount() {
    const temporarySalesInvoiceString = localStorage.getItem(
      props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
    );
    if (temporarySalesInvoiceString == null) {
      return 0;
    }
    const jsonTemporarySalesInvoiceString = JSON.parse(temporarySalesInvoiceString);

    const totalProductUnitWithOrder = jsonTemporarySalesInvoiceString.reduce(
      (partialSum, product) => {
        const totalUnitWithQuantity = product.Units.reduce((unitWithQuantityPartialPrice, unit) => {
          const orderQuantity = unit.order_quantity == null ? 0 : unit.order_quantity;
          if (!isNaN(orderQuantity) && orderQuantity.length > 0 && orderQuantity > 0) {
            return unitWithQuantityPartialPrice + 1;
          }
          return unitWithQuantityPartialPrice;
        }, 0);

        return partialSum + totalUnitWithQuantity;
      },
      0
    );

    return totalProductUnitWithOrder;
  }
  function invoicedQuantity(unit) {
    return unit.order_quantity <= 0 ? "" : unit.order_quantity;
  }

  function priceWithTaxValue(unit) {
    return unit.new_price_with_tax == null ||
      unit.new_price_with_tax.length <= 0 ||
      parseFloat(unit.new_price_with_tax) <= 0
      ? parseFloat(unit.current_price_with_tax)
      : parseFloat(unit.new_price_with_tax);
  }

  function getProductSmallestUOM(uoms) {
    if (uoms.length <= 0) {
      return "";
    }

    return uoms[0].uom;
  }

  function lotNumberAndExpirationInputDialog() {
    if (selectedProductForLotNumberInput == null) {
      return "";
    }

    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          <Dialog
            open={openLotNumberAndExpirationDialogInput}
            onClose={() => {
              setOpenLotNumberAndExpirationDialogInput(false);
            }}
            fullWidth={true}
            maxWidth="md"
          >
            <DialogContent style={{ padding: ".4rem" }}>
              <Typography variant="h6" style={{ color: "black" }} gutterBottom>
                {"Test Product Name"}
              </Typography>
              <Typography variant="subtitle1" gutterBottom>
                <small>Unit :</small> {"CASE"}
              </Typography>

              <List style={{ margin: "0px" }}></List>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setOpenLotNumberAndExpirationDialogInput(false);
                }}
                color="primary"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
  function messageDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowMessageDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  function orderInput(product, unit) {
    return (
      <div>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={materialTheme}>
            <Grid container spacing={1}>
              <Grid
                item
                xs={2}
                style={{
                  display: "inline-grid",
                  justifyItems: "right",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  component="span"
                  style={{ fontWeight: 600, fontSize: "16px" }}
                >
                  <small>{unit.uom}</small>
                </Typography>
              </Grid>
              <Grid item xs={5} style={{ marginTop: ".5em" }}>
                <TextField
                  autoComplete="off"
                  name="quantity"
                  type="number"
                  label="Quantity"
                  variant="outlined"
                  style={{ width: "100%" }}
                  value={invoicedQuantity(unit)}
                  onChange={onOrderOrPriceInputOnChange(product, unit)}
                  InputLabelProps={{ shrink: true }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
              <Grid item xs={5} style={{ marginTop: ".5em" }}>
                <TextField
                  autoComplete="off"
                  name="price"
                  type="number"
                  label="Price"
                  variant="outlined"
                  style={{ width: "100%" }}
                  onBlur={priceInputOnBlur(product, unit)}
                  value={priceWithTaxValue(unit)}
                  onChange={onOrderOrPriceInputOnChange(product, unit)}
                  InputLabelProps={{ shrink: true }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
            </Grid>
          </ThemeProvider>
        </StyledEngineProvider>
      </div>
    );
  }

  function productElement(product) {
    return (
      <Grid container style={{ padding: "0px" }}>
        <Grid container item xs={12}>
          <Grid item xs={12} md={12} lg={12}>
            <Grid container direction="column" justifyContent="space-between" alignItems="stretch">
              <Grid
                item
                container
                onClick={() => {
                  setSelectedProductForLotNumberInput(product);
                  setOpenLotNumberAndExpirationDialogInput(true);
                }}
              >
                <Grid item xs container direction="column" justifyContent="center">
                  <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.brand}</Box>
                  <Box style={{ fontWeight: 600, fontSize: "14px" }}>
                    {product.short_name != "" ? product.short_name : product.name}
                  </Box>
                  <Box>
                    {product.short_name && (
                      <Typography variant="caption">{product.name}</Typography>
                    )}
                  </Box>
                </Grid>
                <Grid item>
                  <IconButton component="span" style={{ height: "100%" }} size="large">
                    <MoreVertIcon />
                  </IconButton>
                </Grid>
              </Grid>
              <Grid item>
                {product.Units.map((unit) => (
                  <React.Fragment key={unit.id}>{orderInput(product, unit)}</React.Fragment>
                ))}
              </Grid>
              {/* <Grid item style={{ fontWeight: 600, fontSize: "14px", color: "red" }}>Available: {product.total_inventory_in_smallest_uom} {getProductSmallestUOM(product.Units)}</Grid> */}
              <Grid item style={{ fontWeight: 600, fontSize: "14px", color: "green" }}>
                Total: ₱
                {product.total_invoiced_amount.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
  function productLists() {
    return (
      <List>
        {products.map((product) => (
          <React.Fragment key={product.id}>
            <ListItem>{productElement(product)}</ListItem>
            <Divider light />
          </React.Fragment>
        ))}
      </List>
    );
  }

  function getOrderPerProductInLocalStorage(temporarySalesInvoice, product) {
    const tempSalesInvoicedIndex = temporarySalesInvoice.findIndex(
      (tempOrder) => tempOrder.code == product.code && tempOrder.company_id == product.company_id
    );
    if (tempSalesInvoicedIndex >= 0) {
      product.Units.forEach((unit, index) => {
        const tempSalesInvoiceUnit = temporarySalesInvoice[tempSalesInvoicedIndex].Units[index];

        unit.order_quantity = tempSalesInvoiceUnit.order_quantity;
        unit.new_price_with_tax = tempSalesInvoiceUnit.new_price_with_tax;
      });
    }
  }
  function checkInvoicedItemIfHasQuantityAndPrice() {
    return products.every((product) => {
      return product.Units.every((unit) => {
        const orderQuantity = unit.order_quantity;
        const priceWithTax =
          unit.new_price_with_tax !== null && unit.new_price_with_tax !== 0
            ? unit.new_price_with_tax
            : unit.current_price_with_tax;

        if (orderQuantity <= 0 && priceWithTax <= 0) {
          return false;
        }
        if (orderQuantity <= 0 && priceWithTax > 0) {
          return false;
        }
        if (orderQuantity > 0 && priceWithTax <= 0) {
          return false;
        }
        if (orderQuantity > 0 && priceWithTax == null) {
          return false;
        }

        if (orderQuantity == null && priceWithTax > 0) {
          return false;
        }
        return true;
      });
    });
  }

  function removeUnitThatHasNoQuantityAndPrice(temporarySaleInvoiced) {
    const filteredProduct = temporarySaleInvoiced.filter((product) => {
      product.Units = product.Units.filter((unit) => {
        return unit.order_quantity > 0;
      });
      return product.Units.length > 0;
    });

    return filteredProduct;
  }
  useEffect(() => {
    if (props.openProductReviewDialog == false) {
      return;
    }

    const temporarySalesInvoiceString = localStorage.getItem(
      props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
    );
    if (temporarySalesInvoiceString == null) {
      return;
    }
    const temporarySaleInvoiced = removeUnitThatHasNoQuantityAndPrice(
      JSON.parse(temporarySalesInvoiceString)
    );

    temporarySaleInvoiced.forEach((product, index) => {
      getOrderPerProductInLocalStorage(temporarySaleInvoiced, product);
      product.total_invoiced_amount = computeTotalInvoiceAmountPerProduct(product);
    });

    setTotalInvoicedAmount(computeOverallTotalInvoiceAmount());
    setInvoicedItemCount(totalInvoicedCount());
    setProducts(temporarySaleInvoiced);
  }, [props.openProductReviewDialog]);
  return (
    <div>
      <Dialog
        fullScreen
        open={props.openProductReviewDialog}
        onClose={props.closeProductReviewDialogHandleClick}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.closeProductReviewDialogHandleClick}
              aria-label="close"
              size="large"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Invoice item review
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.appBarSpacer}></div>
        <Paper square className={classes.productListPaper}>
          {productLists()}
        </Paper>
        <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
          <Toolbar>
            <Typography variant="subtitle1" noWrap>
              Total :{" "}
              {Number(totalInvoicedAmount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
            <div className={classes.grow} />

            <Button
              variant="contained"
              onClick={() => {
                if (checkInvoicedItemIfHasQuantityAndPrice() == false) {
                  setMessageDialogMessage("Please input quantity and price.");
                  setShowMessageDialog(true);
                  return;
                }
                console.log(props);
                props.openInvoiceInformationReviewDialogHandleClick();
              }}
            >
              <Typography variant="caption" noWrap>
                Finalize products
              </Typography>

              <Badge
                badgeContent={invoicedItemCount}
                color="secondary"
                style={{ marginLeft: "1rem" }}
              />
            </Button>
          </Toolbar>
        </AppBar>
      </Dialog>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          {lotNumberAndExpirationInputDialog()}
          {messageDialog()}
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}

export default InputSalesInvoiceProductReview;
